import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const surfSchoolListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fsurf-school.jpg?alt=media&token=66b18208-5fef-43e0-981d-b97a658c7db1",
  title: "Surf School",
  subtitle: "Surf Software Simplified.",
  page: WildNavigationType.SURFSCHOOLS,
}